<div class="dialog-wrapper" role="dialog" aria-modal="true" aria-labelledby="product-warning-title">
  <div class="dialog-icon" aria-hidden="true">
    <div class="icon-circle">
      <img src="assets/agricola/toast-warning.svg" alt="" aria-hidden="true">
    </div>
  </div>

  <h2 id="product-warning-title">Selección de producto requerida</h2>
  <p class="subtitle">
    Debes seleccionar un aliado y un producto, luego presionar <strong>Aplicar</strong> antes de continuar al siguiente paso.
  </p>

  <div class="dialog-actions">
    <app-sis-button (pressed)="close()">Entendido</app-sis-button>
  </div>
</div>
